<!-- src/components/MainTemplate.vue -->
<template>
  <div>
    <router-view />
  </div>
</template>


<style>
.employee-photo {
    width: 60px;
    height: 72px;
    -o-object-fit: cover;
    object-fit: cover;
    margin-right: 4px;
    border-radius: 10%;
    flex-shrink: 0;
}
.employee-photo-extended {
    width: 80px;
    height: 92px;
}
</style>
